import { render, staticRenderFns } from "./document-attachment.vue?vue&type=template&id=60db4e90&"
import script from "./document-attachment.vue?vue&type=script&lang=js&"
export * from "./document-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports